// extracted by mini-css-extract-plugin
export var badge = "_sj-4";
export var selected = "_sj-1";
export var selectedOverlay = "_sj-5";
export var thumbnailButton = "_sj-0";
export var thumbnailFallback = "_sj-3";
export var thumbnailImage = "_sj-2";